import { Component, OnInit } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { AuthService } from "src/app/services/auth/auth.service";
import { ExceptionsService } from "src/app/exceptions/exceptions.service";
import { AlertService } from "src/app/services/alert/alert.service";
import { LoaderService } from "src/app/services/loader/loader.service";
import firebase from "firebase/app";
import { LanguagesService } from "src/app/services/languagesService/languages.service";
import { environment } from "src/environments/environment";
import { UserService } from "src/app/services/user/user.service";
import { RemoteConfigService } from "src/app/services/remote-config/remote-config.service";
import { RouterService } from "src/app/services/router/router.service";
import { ModalController } from "@ionic/angular";

@Component({
  selector: "app-change-email",
  templateUrl: "./change-email.page.html",
  styleUrls: ["./change-email.page.scss"],
})
export class ChangeEmailPage implements OnInit {
  changeEmailForm: FormGroup;
  messageError: Promise<string>;
  LOADER_ID = "change-email";
  userFirebase: firebase.User;
  emailActual = "";
  constructor(
    private formBuilder: FormBuilder,
    private authService: AuthService,
    private exceptionService: ExceptionsService,
    public alertService: AlertService,
    private loaderService: LoaderService,
    public languageService: LanguagesService,
    public userService: UserService,
    public remoteConfig: RemoteConfigService,
    public routerService: RouterService,
    public modalController: ModalController
  ) { }

  async initConstructor() {
    // console.log(this.userFirebase.email);
    this.changeEmailForm = this.formBuilder.group({
      email: [
        this.emailActual
      ],
      password: [
        "",
        Validators.compose([
          Validators.required,
          Validators.minLength(8),
          Validators.pattern("^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-.,'_~~]).{8,}$")
        ]),
      ],
      newEmail: [
        "",
        Validators.compose([
          Validators.required,
          Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')
        ]),
      ],
    });
    this.userFirebase = await this.authService.getUSerInfoFromFirebase();
    this.emailActual = this.userFirebase.email;
    this.changeEmailForm.controls["email"].setValue(this.emailActual);
  }

  ngOnInit() {
    this.initConstructor();
  }

  async setEmailGluky(emailProvider?) {
    let emailChange;
    const { email, password, newEmail } = this.changeEmailForm.value;
    if(!emailProvider){
      emailChange = newEmail;
      this.authService.loginWithUserAndPassword(email, password);
    } else {
      emailChange = emailProvider;
    }
    //Set email users
    const fbToken = await this.authService.callFbToken();
    this.userService.getUserInfo().subscribe(
      async (basicUserInfo: any) => {
        const body = {
          "name": basicUserInfo.name,
          "last_name": basicUserInfo.lastnames,
          "iddoc": basicUserInfo.gnxCredential1,
          "iddoc_type": basicUserInfo.docType,
          "email": emailChange
        }
        if(!body["iddoc"])  delete body["iddoc"];
        if(!body["iddoc_type"])  delete body["iddoc_type"];
        this.authService.updateProfile(body).subscribe((res: any) => {
          console.log(res)
        }, error => {
          console.error(error);
        })
      })
    //Set email user-info
    this.userService.updateField("email", emailChange);
    this.changeEmailForm.reset();
    this.emailActual = emailChange;
    this.changeEmailForm.controls["email"].setValue(this.emailActual);
  }

  async changeEmail() {
    try {
      this.loaderService.presentLoading(this.LOADER_ID);
      const { email, password, newEmail } = this.changeEmailForm.value;

      //firebase user
      const userFirebase: firebase.User = await this.authService.getUSerInfoFromFirebase();
      const credential = firebase.auth.EmailAuthProvider.credential(
        email,
        password
      )
      await userFirebase.reauthenticateWithCredential(credential).then(() => {
        userFirebase.updateEmail(newEmail).then((res)=> {
          this.setEmailGluky();
          this.alertService.presentAlert(
            "El correo electrónico se ha modificado correctamente."
          );
        })
        .catch(error => {
          console.log('error ==',error);
          if (error.code == "auth/email-already-in-use") {
            this.alertService.presentAlert(
              "El correo electrónico que ingresó puede estar en uso u ocurrió un error inesperado."
            );
          }else if(error.code == "auth/requires-recent-login"){
            this.alertService.presentAlert(
              "El correo electrónico que ingresó no se encuentra registrado."
            );
          } else {
            this.alertService.presentAlert(error);
          }
        });
      })
      this.loaderService.cancelLoader(this.LOADER_ID);
      this.modalController.dismiss(null, null, "changeEmail");
      this.routerService.navigate('app/profile/profile-detail')
    } catch (err) {
      console.log(err);
      
      this.loaderService.cancelLoader(this.LOADER_ID);
      this.exceptionService.renderError(err);
    }
  }

  async changeEmailWithGoogle() {
    let currentUser: firebase.User = await this.authService.getUSerInfoFromFirebase();
    const hasGoogle = currentUser.providerData.reduce((has, provider) => {
      if (has) { 
        return true; 
      }
      return provider.providerId === "google.com";
    }, false);
    if(hasGoogle){
      currentUser.unlink("google.com");
    }
    var provider = new firebase.auth.GoogleAuthProvider();
    provider.addScope('profile');
    provider.addScope('email');

    try {
      await this.changeEmailProvider(currentUser, provider)
    } catch (error) {
      throw new Error(error);
    }
  }

  async changeEmailProvider(currentUser, provider){
    try {
      const result = await currentUser.linkWithPopup(provider);
      const credential = result.credential;
      const user = result.additionalUserInfo.profile as any;
      currentUser = result.user;
      if (user.email && user.email != currentUser.email) {
        currentUser.updateEmail(user.email);
      }
      this.setEmailGluky(currentUser.email);
      this.alertService.presentAlert("Correo actualizado correctamente");
      this.routerService.redirect("app/profile/profile-detail");
    } catch (error) {
      let msj = "";
      switch (error.code) {
        case "auth/auth-domain-config-required":
          msj = "AuthDomain Requerido"
          break;
        case "auth/cancelled-popup-request":
          msj = "Sólo se permite una solicitud de popup a la vez en un usuario o una instancia de auth"
          break;
        case "auth/credential-already-in-use":
          msj = "Esta credencial ya está en uso"
          break;
        case "auth/email-already-in-use":
          msj = "Email ya esá en uso"
          break;
        case "auth/operation-not-allowed":
          msj = "No se ha habilitado el proveedor en la consola de Firebase."
          break;
        case "auth/popup-blocked":
          msj = "Popup bloqueado"
          break;
        case "auth/operation-not-supported-in-this-environment":
          msj = "La ventana emergente ha sido bloqueada por el navegador"
          break;
        case "auth/popup-closed-by-user":
          msj = "La ventana emergente ha sido cerrada sin completar el registro en el proveedor"
          break;
        case "auth/provider-already-linked":
          msj = "Proveedor ya usado"
          break;
        case "auth/unauthorized-domain":
          msj = "El dominio de la aplicación no está autorizado para las operaciones OAuth "
          break;
        case "auth/no-such-provider":
          msj = "No ha seleccionado una cuenta"
          break;
        default: msj = error.code
          break;
      }
      this.loaderService.cancelLoader(this.LOADER_ID);
      this.alertService.showErrorAlert(msj)
    }
  }

  async changeEmailWithMicrosoft() {

    let currentUser: firebase.User = await this.authService.getUSerInfoFromFirebase();
    const hasMicrosoft = currentUser.providerData.reduce((has, provider) => {
      if (has) { 
        return true; 
      }
      return provider.providerId === "microsoft.com";
    }, false);
    if(hasMicrosoft){
      currentUser.unlink("microsoft.com");
    }
    var provider = new firebase.auth.OAuthProvider('microsoft.com');
    provider.addScope('profile');
    provider.addScope('email');
    provider.setCustomParameters({
      prompt: "consent",
      tenant: "aab206e5-1c96-4876-bab7-c34f2b00ba7f",
    });
    try {
      await this.changeEmailProvider(currentUser, provider)
    } catch (error) {
      throw new Error(error);
    }

  }

  get getInputError() {
    return this.languageService.textsIU.input_error;
  }

  get getTextIUPageEmail() {
    return this.languageService.textsIU.page_change_email;
  }

  seePassword(input, icon) {
    input.type = input.type == 'text' ? 'password' : 'text';
    icon.name = icon.name == 'eye-outline' ? 'eye-off-outline' : 'eye-outline';
  }

  getValidations(name, nameField) {
    const container = document.getElementById(`${name}Errors`);
    container.innerHTML = '';
    let htmlError = '';
    //Validaciones
    if (this.changeEmailForm.get(name)?.hasError('required')) {
      htmlError += `<p>${nameField} requerido.</p> `;
    }
    if (this.changeEmailForm.get(name)?.hasError('minlength')) {
      htmlError += `<p>${nameField} debe tener mínimo ${this.changeEmailForm.get(name)?.errors.minlength.requiredLength} carácteres.</p> `;
    }
    if (this.changeEmailForm.get(name)?.hasError('maxlength')) {
      htmlError += `<p>${nameField} debe tener máximo ${this.changeEmailForm.get(name)?.errors.maxlength.requiredLength} carácteres.</p> `;
    }
    if (this.changeEmailForm.get(name)?.hasError('pattern')) {
      if (name == 'password') {
        htmlError += `<p>La contraseña debe incluir números, minúsculas, mayúsculas y carácteres especiales ('.-_!#^~@$)</p>`;
      }
      if (name == 'newEmail') {
        htmlError += `<p>Ingresa un correo valido</p>`;
      }
    }
    container.insertAdjacentHTML('afterbegin', htmlError);
  }
}